import React, { Component } from "react";
import {
  Container,
  Grid,
  Typography,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Button
} from '@mui/material';
import { list } from "./apiUser";
import DefaultProfile from "../images/avatar.png";
import { Link } from "react-router-dom";

class Users extends Component {
    constructor() {
        super();
        this.state = {
            users: []
        };
    }

    componentDidMount() {
        list().then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.setState({ users: data });
            }
        });
    }

    renderUsers = users => (
        <Grid container spacing={2}>
            {users.map((user, i) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
                    <Card>
                        <CardMedia
                            component="img"
                            height="200"
                            image={`${process.env.REACT_APP_API_URL}/user/photo/${user._id}`}
                            alt={user.name}
                            onError={(e) => { e.target.src = DefaultProfile; }}
                        />
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                {user.name}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {user.email}
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button
                                component={Link}
                                to={`/user/${user._id}`}
                                variant="contained"
                                color="primary"
                                size="small"
                            >
                                View Profile
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
            ))}
        </Grid>
    );

    render() {
        const { users } = this.state;
        return (
            <Container>
                <Typography variant="h4" sx={{ mt: 5, mb: 5 }}>
                    Users
                </Typography>

                {this.renderUsers(users)}
            </Container>
        );
    }
}

export default Users;